import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgEdit(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.41406L13.0607 7.3534L15.6464 9.93919L17.5858 7.99985L15 5.41406ZM9.06066 11.3534L12.3536 8.06051L14.9393 10.6463L11.6464 13.9392L9.06066 11.3534ZM8.35355 12.0605L8 12.4141V14.9998L10.5858 14.9999L10.9393 14.6463L8.35355 12.0605ZM7.29289 11.707C7.10536 11.8945 7 12.1488 7 12.4141V14.9998C7 15.5521 7.44772 15.9998 8 15.9998H10.5858C10.851 15.9998 11.1054 15.8945 11.2929 15.707L18.2929 8.70696C18.6834 8.31643 18.6834 7.68327 18.2929 7.29274L15.7071 4.70696C15.3166 4.31643 14.6834 4.31643 14.2929 4.70696L7.29289 11.707Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);

var EditOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { EditOutline as default };
